var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{style:(_vm.cssStyles()),attrs:{"xl":_vm.xl.cols,"lg":_vm.lg.cols,"md":_vm.md.cols,"sm":_vm.sm.cols,"cols":_vm.xs.cols || 12}},[_c('panels-responsive',{attrs:{"spec":_vm.spec}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }